// extracted by mini-css-extract-plugin
export var backupIcon = "_s9-1";
export var image = "_s9-0";